import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { useEffect } from 'react'
import Select from 'react-select'
import makeAnimated from 'react-select/animated'
const EmployeeStatusSelect = ({ setSelectedStatus, isMulti }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [isLoading, setLoading] = useState(true)

  const data = [
    {
      id: 4,
      label: t('hooks.employeeStatusSelect.all'),

      value: 4,
    },
    {
      id: 1,
      label: t('hooks.employeeStatusSelect.waiting'),

      value: 1,
    },
    {
      id: 2,
      label: t('hooks.employeeStatusSelect.inProgress'),
      value: 2,
    },
    {
      id: 3,
      label: t('hooks.employeeStatusSelect.completed'),

      value: 3,
    },
  ]
  const animatedComponents = makeAnimated()
  const handleSelect = (dataEmployees) => {
    setSelectedStatus(dataEmployees.label)
  }
  useEffect(() => {
    if (data[0]?.length !== 0) {
      setLoading(false)
    }
  }, [data])
  const selectInfoStyles = {
    width: '100%', 
    zIndex: 9995, 
    maxWidth: '100vh', 
    minWidth: '100vh', 
  };


  const mobileStyles = {
    maxWidth: '100%',
    minWidth: '100%', 
  };
  return (
    <div style={{  ...selectInfoStyles, ...mobileStyles }}>
      <Select
        closeMenuOnSelect={true}
        components={animatedComponents}
        options={data}
        onChange={handleSelect}
        isSearchable={true}
        placeholder={t('hooks.employeeStatusSelect.placeholder')}
        autosize={true}
        noOptionsMessage={() => t('hooks.common.noResults')}
        isLoading={isLoading}
      />
    </div>
  )
}

export default EmployeeStatusSelect
